import React from 'react';
import { Button, } from '@waglabs/button-next';
import { CloseIcon } from '@waglabs/icons';
export const ModalCloseIconButton = ({ iconProps, ...rest }) => (React.createElement(Button, Object.assign({ bg: "transparent", border: 0, minWidth: "initial", p: "12px", position: "absolute", right: "4px", top: "4px" }, rest),
    React.createElement(CloseIcon, Object.assign({ hover: true }, iconProps))));
